import React from 'react';
import { isCampaignLive } from './calendarUtils';

interface StatusIndicatorProps {
  status: string;
  campaign?: any;
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status, campaign }) => {
  if (status?.toLowerCase() !== 'posted') {
    return null;
  }

  const isLive = campaign ? isCampaignLive(campaign) : true;

  if (!isLive) {
    return null;
  }

  return (
    <div className="absolute top-2 right-2">
      <div className="relative flex items-center justify-center">
        <div className="absolute w-3 h-3 rounded-full bg-[#ee4425] animate-ping opacity-75"></div>
        <div className="relative w-2 h-2 rounded-full bg-[#ee4425]"></div>
      </div>
    </div>
  );
};

export default StatusIndicator;
